<template>
  <div>

    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #fff2d6;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 1"
    >
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #ffb102">MTN Mobile Money</p>
    </div>

    <div
      style="
    display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #fff2d6;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 6"
    >
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #ffb102">Master Card</p>
    </div>

    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #d1edfc;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 7"
    >
      <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #41c4fd">Cash</p>
    </div>
    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #418a49;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 5"
    >
      <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">Bank</p>
    </div>
    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #ff000073;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 2"
    >
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">VODAFONE Cash</p>
    </div>
 
    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #fff2d6;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 3"
    >
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #ffb102">AIRTEL Cash</p>
    </div>

    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #fff2d6;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 4"
    >
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #ffb102">TIGO Cash</p>
    </div>

    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #0096889e;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 8"
    >
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">Credit</p>
    </div>
    <div
      style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #3f51b5;
        width: 140px;
        height: 27px;
        border-radius: 30px;
      "
      v-if="displayStatusLabel === 0"
    >
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">VISA</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "PaymentIssuerStatus",
  props: ["status"],
  data() {
    return {
      statusLabel: this.status,
    };
  },
  computed: {
    displayStatusLabel() {
      return this.statusLabel;
    },
  },
  watch: {
    status: {
      immediate: true,
      handler(newValues) {
        this.statusLabel = newValues;
      },
    },
  },
};
</script>

<style scoped>
</style>